<template>
  <div class="profile-menu float-right">
    <a
      v-if="!$root.isLoggedIn"
      class="header-button clearfix profile-button"
      :href="route('login')"
    >
      <icon icon="user" class="icon" />
      <span class="text">My Account</span>
    </a>
    <ContextMenu v-else id="profile-menu-dropdown" :items="menu" align="right">
      <span class="header-button clearfix profile-button">
        <icon icon="user" class="icon" />
        <span class="text">{{ $root.user.name }}</span>
      </span>
    </ContextMenu>
  </div>
</template>

<script>
export default {
  computed: {
    menu() {
      let menu = [];
      menu.push({
        label: "My Profile",
        action: () => {
          this.goToRoute("training.users.show", { user: this.$root.user.id });
        },
      });
      menu.push({
        label: "My Wishlist",
        action: () => {
          this.goToRoute("training.users.wishlist", { user: this.$root.user.id });
        },
      });
      if (!this.$root.isPublicUser) {
        menu.push({
          label: "My Hours",
          action: () => {
            this.showHoursModal();
          },
        });
      }
      if (this.$root.isTrainer) {
        menu.push({
          label: "Manage Calendar",
          action: () => {
            this.goToRoute("profile.calendar.index", {
              trainer: this.$root.user.id
            });
          },
        });
      }
      if (
        this.$root.isTrainer ||
        this.$root.isManager ||
        this.$root.isLocalContact
      ) {
        menu.push({
          label: "Settings",
          action: () => {
            this.goToRoute("profile.settings.index");
          },
        });
      }
      if (
          this.$root.isDealer
      ) {
        menu.push({
          label: "Create an Account",
          action: () => {
            this.goToRoute("profile.accounts.create");
          },
        });
      }
      menu.push({
        label: "Log Out",
        action: () => {
          this.goToRoute("logout");
        },
      });
      return menu;
    },
  },

  methods: {
    showHoursModal() {
      this.$modal("HoursModal", { user: this.$root.user })
        .then(() => {})
        .catch(() => {});
    },
  },
};
</script>
